module.exports = __webpack_public_path__ + "static/media/(DH)-Artesanato-21.af8be8fa.jpg";